import {React, useContext} from 'react';


import { UserContext } from '../../store/UserContext';

import { HeaderStyled, Icon, Infos, PointerExit } from './styles';

import { useHistory } from 'react-router-dom';

import getImage from '../../firestore/getImage';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
const Header = () => {

  const { data, userLogout, whitelabel } = useContext(UserContext); // data contem as informações do usuário

  const icon = getImage(whitelabel.systemProject[0].logo.icon)

  const history = useHistory();

  if(data === null){

    return (
      <HeaderStyled whitelabel={whitelabel.systemProject[0].colors}>
        <Link href={"/"} underline="none"> 
          <Icon image={icon} onClick={() => history.push("/")}/>
        </Link>
        <Infos>
          <Typography >Bem vindo </Typography>
          <PointerExit>
            <ExitToAppIcon onClick={userLogout}/>
          </PointerExit>
        </Infos>
    </HeaderStyled>
    )
  }else{
    return (
      <HeaderStyled whitelabel={whitelabel.systemProject[0].colors}>
        <Icon image={icon} onClick={() => history.push("/")}/>
        <Infos>
          <Typography >Bem vindo, {data.name} </Typography>
          <PointerExit>
            <ExitToAppIcon onClick={userLogout}/>
          </PointerExit>
        </Infos>
      </HeaderStyled>
    )
  }

}

export default Header;